export const getLocalCache = (cacheKey, cacheDurationMs) => {
  const cached = localStorage.getItem(cacheKey);
  if (!cached) {
    return null;
  }

  try {
    const parsed = JSON.parse(cached);
    const now = Date.now();
    if (now - parsed.timestamp < cacheDurationMs) {
      return parsed.data;
    } else {
      localStorage.removeItem(cacheKey);
      return null;
    }
  } catch (err) {
    localStorage.removeItem(cacheKey);
    return null;
  }
};

export const setLocalCache = (cacheKey, data) => {
  const payload = {
    timestamp: Date.now(),
    data,
  };
  try {
    localStorage.setItem(cacheKey, JSON.stringify(payload));
  } catch (err) {
    // Never let caching crash the caller. QuotaExceededError (storage full) is
    // the common case — drop this key and move on; the app just recomputes
    // next time instead of serving from cache.
    // eslint-disable-next-line no-console
    console.warn(`setLocalCache: could not cache "${cacheKey}" (${err?.name || err}). Skipping.`);
    try {
      localStorage.removeItem(cacheKey);
    } catch (e) {
      /* ignore */
    }
  }
};